<script setup lang="ts">
import { computed } from "vue";

import { selectionActions } from "@/action/selectionActions";
import { actionSourceKey } from "@/components/action/injectKeys";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
import { useBoardStore } from "@/store/board";
import { injectStrict } from "@/utils/vue";

const dropdown = injectStrict(dropdownKey);
const actionSource = injectStrict(actionSourceKey);

const count = computed(() => useBoardStore().selectedStickyIds.length);

function stickyLinkToClipboard() {
  void selectionActions.share(actionSource);
  dropdown.close();
}
</script>

<template>
  <MenuList role="dialog">
    <MenuListItems>
      <MenuListItem @click="stickyLinkToClipboard">
        {{ $t("label.actionMenu.stickyLinkToClipboard", count) }}
      </MenuListItem>
    </MenuListItems>
  </MenuList>
</template>
